import { render, staticRenderFns } from "./CheckProducts.vue?vue&type=template&id=071183d5&scoped=true&"
import script from "./CheckProducts.vue?vue&type=script&lang=js&"
export * from "./CheckProducts.vue?vue&type=script&lang=js&"
import style0 from "./CheckProducts.vue?vue&type=style&index=0&id=071183d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071183d5",
  null
  
)

export default component.exports